import { render, staticRenderFns } from "./FindOutAboutUs.vue?vue&type=template&id=22535fed"
import script from "./FindOutAboutUs.vue?vue&type=script&lang=js"
export * from "./FindOutAboutUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports